// extracted by mini-css-extract-plugin
export default {"block":"Hm","select":"Im","empty":"Jm","open":"Km","error":"Lm","options":"Mm","selectActive":"Nm","ornament":"Om"};